import { Box, makeStyles } from '@material-ui/core'
import arrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { scrollToTop } from 'src/utils/commonMethods'
import { showNotificationMessage, updatePlanDetails } from 'src/actions'
import { useHistory } from 'react-router-dom'
import LoadingModal from 'src/components/common/LoadingModal'
import { getTokenForQrReport } from 'src/services/individualService'
import { getPlanDetails } from 'src/services/buyPolicyService'
import CoveragesLists from 'src/components/BuyPolicy/insuranceScreens/health/PlanDetails/CoveragesLists'
import NotCoveredCoverages from 'src/components/BuyPolicy/insuranceScreens/health/PlanDetails/NotCoveredCoverages'
import AssistanceClaim from 'src/components/BuyPolicy/insuranceScreens/health/PlanDetails/AssistanceClaim'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { COVERAGE_TABS } from 'src/utils/constants/Health'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const PlanDetails = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const planDetailsQuote = guestUserDetails?.planDetailsQuote
  const [planDetailsData, setPlanDetailsData] = useState()
  const [coverageTabList, setCoverageTabList] = useState([])
  const providerId = guestUserDetails?.planDetailsQuote?.providerId
  const insuranceId = guestUserDetails?.planDetailsQuote?.insuranceId

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    scrollToTop()
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getCoveragesTabs = (data) => {
    const coverageTabs = []

    if (data?.topCoverages?.length) {
      coverageTabs?.push(COVERAGE_TABS?.TOP)
    }
    if (data?.waitingCoverages?.length) {
      coverageTabs?.push(COVERAGE_TABS?.WAITING)
    }
    if (data?.valueAddedCoverages?.length) {
      coverageTabs?.push(COVERAGE_TABS?.VALUE_ADDED)
    }
    if (data?.additionalCoverages?.length) {
      coverageTabs?.push(COVERAGE_TABS?.ADDITIONAL)
    }
    if (data?.conditionalCoverages?.length) {
      coverageTabs?.push(COVERAGE_TABS?.CONDITIONAL)
    }

    setCoverageTabList(coverageTabs)
  }
  const handleBack = () => {
    dispatch(updatePlanDetails(null))
    history.push('/individual/dashboard/buyPolicy/health/insuranceDetails')
  }

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      await fetchPlanDetails(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchPlanDetails = async (token) => {
    setLoading(true)
    const response = await getPlanDetails(token, providerId, insuranceId)

    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      } else {
        setLoading(false)
        const responseData = response?.res?.data
        getCoveragesTabs(responseData)
        setPlanDetailsData(responseData)
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const scrollToComponent = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.planDetails}>
        <div
          onClick={handleBack}
          className={classes.goBackContainer}
          id='backButton'
        >
          <img src={arrow} alt='arrow' />
          <span className={classes.goBackButton}>Quotes</span>
        </div>
        <div className={classes.planDetailsHeading}>
          <div className={classes.providerImage}>
            <img src={planDetailsQuote?.providerImage} alt='digit' />
          </div>
          <div className={classes.planDetailsTitleContainer}>
            <span className={classes.planDetailsTitleContent}>
              {planDetailsQuote?.insuranceName}
            </span>
            <span className={classes.planDetailsTitleSubContent}>
              {planDetailsQuote?.providerName}
            </span>
          </div>
        </div>

        <Box className={classes.boxContainer}>
          <div className={classes.coverageTabContainer}>
            {coverageTabList?.map((coverageTab) => (
              <div
                className={classes.coverageTab}
                onClick={() => scrollToComponent(coverageTab?.id)}
                key={coverageTab?.id}
                id='coverageTabScroll'
              >
                {coverageTab?.label}
              </div>
            ))}
          </div>

          {planDetailsData?.topCoverages?.length && (
            <div id='topCoverages'>
              <CoveragesLists
                coverages={planDetailsData?.topCoverages}
                coverageTitle={'Top Coverages'}
              />
            </div>
          )}

          <NotCoveredCoverages />

          {planDetailsData?.waitingCoverages?.length && (
            <div id='waitingCoverages'>
              <CoveragesLists
                coverages={planDetailsData?.waitingCoverages}
                coverageTitle={'Waiting Coverages'}
              />
            </div>
          )}

          <AssistanceClaim />
          {planDetailsData?.valueAddedCoverages?.length && (
            <div id='valueAddedCoverages'>
              <CoveragesLists
                coverages={planDetailsData?.valueAddedCoverages}
                coverageTitle={'Value Added Coverages'}
              />
            </div>
          )}

          {planDetailsData?.additionalCoverages?.length && (
            <div id='additionalCoverages'>
              <CoveragesLists
                coverages={planDetailsData.additionalCoverages}
                coverageTitle={'Additional Coverages'}
              />
            </div>
          )}

          {planDetailsData?.conditionalCoverages?.length && (
            <div id='conditionalCoverages'>
              <CoveragesLists
                coverages={planDetailsData?.conditionalCoverages}
                coverageTitle={'Conditions'}
              />
            </div>
          )}
        </Box>
      </div>
    </>
  )
}

export default PlanDetails

const useStyles = makeStyles({
  planDetails: {
    width: '100%',
    backgroundColor: 'white',
  },
  goBackContainer: {
    display: 'flex',
    cursor: 'pointer',
    gap: '5px',
    padding: '0px 25px',
  },
  goBackButton: {
    fontSize: '20px',
    cursor: 'pointer',
    fontWeight: '400',
  },
  providerImage: {
    border: '1px solid #DDC8A3',
    borderRadius: '10px',
    padding: '10px 20px 10px 20px',
    background: '#F5F2EA',
  },
  planDetailsHeading: {
    display: 'flex',
    padding: '25px',
  },
  planDetailsTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
  },
  planDetailsTitleContent: {
    fontSize: '22px',
    color: '#2BA6C8',
  },
  planDetailsTitleSubContent: {
    fontSize: '14px',
    color: '#5B5B5B',
  },
  boxContainer: {
    height: 'fit-content',
    padding: '0px 25px 25px 25px',
  },
  tab: {
    textTransform: 'unset !important',
    fontSize: '15px !important',
    color: '#000000 !important',
    minWidth: '17% !important',
  },
  tabSelected: {
    fontSize: '16px',
    color: '#1EA8CE',
    fontWeight: '550',
  },
  tabPanel: {
    padding: '35px 0px',
  },
  tabLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '10px',
  },
  tabLabelIcon: {
    height: '22px',
    width: '22px',
  },

  scrollItemsContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: '10px',
  },
  coverageTabContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  coverageTab: {
    padding: '5px 10px !important',
    cursor: 'pointer !important',
    '&:hover': {
      color: '#1EA8CE !important',
      textTransform: 'unset !important',
      borderBottom: '3px solid #1EA8CE !important',
    },
    fontSize: '15px !important',
    fontWeight: '600 !important',
    color: '#000000 !important',
  },
})
